import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className={`ri-book-open-line text-xl ${isScrolled ? 'text-primary-500' : 'text-background-50'}`}></i>
          </div>
          <span className={`text-lg font-bold font-heading ${isScrolled ? 'text-foreground-900' : 'text-background-50'}`}>
            桃桃漫画
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <Link
            to="/"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/90 hover:text-background-50'
            } ${location.pathname === '/' ? (isScrolled ? 'text-primary-500' : 'text-background-50') : ''}`}
          >
            首页
          </Link>
          <div className="relative group">
            <button
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap flex items-center gap-1 cursor-pointer ${
                isScrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/90 hover:text-background-50'
              } ${location.pathname.startsWith('/category') ? (isScrolled ? 'text-primary-500' : 'text-background-50') : ''}`}
            >
              分类
              <i className="ri-arrow-down-s-line w-4 h-4 flex items-center justify-center"></i>
            </button>
            <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
              <div className="bg-background-50 rounded-lg py-2 min-w-[160px] border border-background-200/70">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="block px-4 py-2 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50 transition-colors duration-150 whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                    <span className="text-foreground-400 text-xs ml-2">({cat.count})</span>
                  </Link>
                ))}
              </div>
            </div>
          </div>
          <Link
            to="/about"
            className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/90 hover:text-background-50'
            } ${location.pathname === '/about' ? (isScrolled ? 'text-primary-500' : 'text-background-50') : ''}`}
          >
            关于我们
          </Link>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <button
            className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
              isScrolled
                ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                : 'bg-background-50 text-primary-500 hover:bg-background-100'
            }`}
          >
            开始阅读
          </button>
        </div>

        <button
          className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${isScrolled ? 'text-foreground-800' : 'text-background-50'} ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
          <div className="flex flex-col gap-3">
            <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 cursor-pointer">首页</Link>
            <div className="text-sm font-medium text-foreground-700 py-2">分类</div>
            <div className="grid grid-cols-2 gap-2 pl-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-600 hover:text-primary-500 py-1 cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
            <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 cursor-pointer">关于我们</Link>
            <button className="bg-primary-500 text-background-50 rounded-full px-5 py-2 text-sm font-medium text-center whitespace-nowrap cursor-pointer">
              开始阅读
            </button>
          </div>
        </div>
      )}
    </header>
  );
}